import apiClient, { type ApiInterface } from 'src/modules/api';
import React from 'react';
import type { Zone } from '@seek/audience-zones';

export interface Config {
  api: ApiInterface;
}
const ApiContext = React.createContext<Config | undefined>(undefined);

export const useApiClient = (): ApiInterface => {
  const context = React.useContext(ApiContext);
  if (context === undefined) {
    throw new Error('useApiClient must be used within an ApiProvider');
  }
  return context.api;
};

export const ApiProvider = ({
  useMocks,
  isServer,
  children,
  zone,
}: {
  useMocks?: boolean;
  isServer?: boolean;
  children: React.ReactNode;
  zone: Zone;
}) => {
  const api = apiClient({
    useMocks: useMocks ?? window.CONFIG.ENV === 'local',
    isServer,
    zone,
  });

  return <ApiContext.Provider value={{ api }}>{children}</ApiContext.Provider>;
};
